enum EconomicScaleEnum {
  Economy = 'Economy',
  Midscale = 'Midscale',
  Upscale = 'Upscale',
  Luxury = 'Luxury',
}

export default EconomicScaleEnum;
